import { PublicClientApplication, RedirectRequest } from "@azure/msal-browser";
import { BasicRoutePath } from "@/constants";
import { config } from "@/guards/auth/azure-b2c.config";

export const b2cPolicies = {
  auth: {
    authority: `https://${config.tenantName}.b2clogin.com/${config.tenantName}.onmicrosoft.com/${config.policyNames?.signIn}`,
    clientId: config.clientId,
    knownAuthorities: [`${config.tenantName}.b2clogin.com`],
    redirectUri: BasicRoutePath.Home,
    postLogoutRedirectUri: BasicRoutePath.Home,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      logLevel: 3,
      piiLoggingEnabled: false,
    },
  },
};

export const redirectRequestConfig: RedirectRequest = {
  scopes: config?.scopes ? [...config.scopes] : [],
  redirectStartPage: window.location.href,
};

export const redirectForgotPasswordRequestConfig = {
  ...redirectRequestConfig,
  authority: `https://${config.tenantName}.b2clogin.com/${config.tenantName}.onmicrosoft.com/${config.policyNames?.forgotPassword}`,
};

export const msalInstance = new PublicClientApplication(b2cPolicies);
